<template>
  <div>
    <!-- Header -->
    <div class="header  py-7 py-lg-8 pt-lg-9">
      
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">

      <div slot="brand" class="text-center col-12 p-4">
        <img src="/img/brand/food-drop-logo-white.svg" style="width: 16rem;">
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7" v-if="passwordResetSent === false">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">

              <div class="text-center text-muted mb-4">
                <small>Reset your password</small>
              </div>

              <div>
                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-email-83"
                            type="email"
                            placeholder="Email"
                            autofocus
                            v-model="model.email"
                            @keypress.enter="doSendPasswordReset()">
                </base-input>

                <div class="text-center">
                  <base-button type="primary" class="my-4" @click="doSendPasswordReset()">Reset password</base-button>
                </div>
              </div>

            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 text-left">
              <router-link to="/auth/login" class="text-white"><small><span class="fa fa-arrow-left"></span>&nbsp;&nbsp;Back to login</small></router-link>
            </div>
          </div>

        </div>

        <div class="col-lg-5 col-md-7" v-if="passwordResetSent === true">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">

              <div class="text-center text-muted mb-4">
                <small>Reset your password</small>
              </div>

              <div class="text-center">
                A password reset email has been sent to {{ this.model.email }}
              </div>

            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 text-left">
              <router-link to="/auth/login" class="text-white"><small><span class="fa fa-arrow-left"></span>&nbsp;&nbsp;Back to login</small></router-link>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Services
  import AuthService from '../../../services/AuthService'
  import UsersService from '../../../services/UsersService'
  import UserStore from '../../../services/UserStore'

  export default {
    data() {
      return {
        passwordResetSent: false,
        model: {
          email: ''
        }
      };
    },

    created: async function() {
      
    },

    methods: {
      async doSendPasswordReset() {
        const result = await AuthService.sendPasswordReset(this.model.email);
        if(result === true) {
          this.passwordResetSent = true;
        }
        else if(result === 404) {
          alert('The email address provided was not found.');
        }
        else {
          alert('Oops, something went wrong. Please try again...');
        }
      }
    }
  };
</script>
